<template>
  <div class="wizard-panel">
    <div class="wizard-card">
      <div class="wizard-card-content">
        <svg v-if="currStep >= 3" version="1.1" id="spinner" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 128 128" enable-background="new 0 0 128 128" xml:space="preserve">
          <rect width="64" height="64" fill="#8FCEA8" class="animate-fill"></rect>
          <rect x="64" width="64" height="64" fill="#EE5595" class="animate-fill delay-2"></rect>
          <rect x="64" y="64" width="64" height="64" fill="#FFFFFF" class="animate-fill delay-4"></rect>
          <rect y="64" width="64" height="64" fill="#9CAFDA" class="animate-fill delay-6"></rect>

          <g id="dropper">
            <polygon class="animate-fill delay-2" fill="#ffffff" points="23.5,34.1 20.7,39 22.1,42.5 25.6,43.9 34.6,34.1"></polygon>
            <path class="animate-stroke delay-1" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" d="M27.2,42.3c-1.5,1.5-3.8,1.5-5.3,0l-0.2-0.2c-1.5-1.5-1.5-3.8,0-5.3l17.6-17.6c1.5-1.5,3.8-1.5,5.3,0l0.2,0.2
              c1.5,1.5,1.5,3.8,0,5.3L27.2,42.3z"></path>
            <line class="animate-stroke delay-1" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="30.8" y1="20.6" x2="43.9" y2="33.7"></line>
            <line class="animate-stroke delay-1" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="18.1" y1="45.9" x2="22.5" y2="41.5"></line>
          </g>
          <g id="brush">
            <rect class="animate-fill delay-4" x="87.9" y="15.8" fill="#ffffff" width="16.1" height="9.6"></rect>
            <rect class="animate-stroke delay-3" x="88.3" y="16.9" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" width="15.4" height="22"></rect>
            <line class="animate-stroke delay-3" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="87.9" y1="30.9" x2="104.1" y2="30.9"></line>
            <path class="animate-stroke delay-3" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" d="M99.1,38.8v5.9c0,1.6-1.4,3-3,3l0,0c-1.6,0-3-1.4-3-3v-5.9"></path>
            <line class="animate-stroke delay-3" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="94.9" y1="22.4" x2="94.9" y2="16.5"></line>
          </g>
          <g id="nodes">
            <line class="animate-stroke delay-7" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="23.2" y1="100.4" x2="23.2" y2="91"></line>
            <line class="animate-stroke delay-7" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="36.3" y1="104.7" x2="27.6" y2="104.7"></line>
            <line class="animate-stroke delay-7" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="40.7" y1="91.6" x2="40.7" y2="100.4"></line>
            <line class="animate-stroke delay-7" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" x1="26.9" y1="87.3" x2="36.3" y2="87.3"></line>
            
            <rect class="animate-fill delay-8" x="19.2" y="83.2" fill="#ffffff" width="8.1" height="8.1"></rect>
            <rect class="animate-fill delay-8" x="36.7" y="83.2" fill="#ffffff" width="8.1" height="8.1"></rect>
            <rect class="animate-fill delay-8" x="19.2" y="100.7" fill="#ffffff" width="8.1" height="8.1"></rect>
            <rect class="animate-fill delay-8" x="36.7" y="100.7" fill="#ffffff" width="8.1" height="8.1"></rect>
            
            <rect class="animate-stroke delay-7" x="19.2" y="83.2" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" width="8.1" height="8.1"></rect>
            <rect class="animate-stroke delay-7" x="36.7" y="83.2" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" width="8.1" height="8.1"></rect>
            <rect class="animate-stroke delay-7" x="19.2" y="100.7" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" width="8.1" height="8.1"></rect>
            <rect class="animate-stroke delay-7" x="36.7" y="100.7" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" width="8.1" height="8.1"></rect>
          </g>
          <g id="pencil">
            <polygon class="animate-stroke delay-5" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" points="100,104.8 100.5,105.3 109.1,109.1 105.3,100.5 104.8,100 	"></polygon>
            <path class="animate-stroke delay-5" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" d="M90.9,86.1l13.3,13.3l-4.8,4.8L86.1,90.8l4.4-4.4L90.9,86.1z"></path>
            <path class="animate-fill delay-6" fill="#ffffff" d="M89.9,85l-2-2c-0.2-0.2-0.7-0.2-1,0.1l-3.8,3.8c-0.3,0.3-0.3,0.7-0.1,1l2,2"></path>
            <path class="animate-stroke delay-5" fill="none" stroke="#292E34" stroke-width="3" stroke-miterlimit="10" d="M90.9,86l-3-3c-0.2-0.2-0.7-0.2-1,0.1l-3.8,3.8c-0.3,0.3-0.3,0.7-0.1,1l3,3"></path>
          </g>
        </svg>
        <h2>GENERATING LOGOS</h2>
        <div ref="percent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  name: 'BrandEnd',
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters('wizard', [
      'currStep',
    ]),
  },
  methods: {
    ...mapActions('wizard', [
      'nextStep'
    ]),
    animate_to(percent) {
      var el = this.$refs.percent;
      el.innerText = percent+'%';
    },
    animate(duration) {
      var steps = [];
      for(var i=0; i<50; i++){
        steps.push(Math.floor(Math.random()*100));
      }
      steps.sort();
      for(i=1; i<steps.length; i++){
        window.setTimeout(this.animate_to.bind(this, steps[i]), duration*steps[i]/100);
      }
      this.animate_to(0, steps[0]);
    }
  },
  watch: {
    currStep() {
      if(this.currStep >= 3) {
        var delay = 10000;
        this.animate(delay);
        // window.setTimeout(function(){
        //   window.location.reload(true);
        // }, delay+700);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.wizard-panel {
  z-index: 1;
  font-size: 0.8em;

  h2 {
    font-weight: 500;
  }

  & .wizard-card:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 2em;
    max-height: 100%;
    color: $charcoal-grey;
    height: 100%;

    .wizard-card-content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &.active .wizard-card:nth-child(1) {
    transform: translate(0);
  }
}

@media (min-width: 768px) {
  .wizard-panel {
    font-size: 1em;

    &.active .wizard-card:nth-child(1) {
      padding-left: 5em;
    }
  }
}

.wizard-card:nth-child(1) {
  background-color: $pale-gold;
}

#spinner{
	width: 10em;
	height: 10em;
}

#spinner .animate-fill{
  opacity: 0;
  animation: fadein 1s ease-in-out forwards;
}

@keyframes fadein {
  to {
    opacity: 1;
  }
}


#spinner .animate-stroke{
  stroke-dasharray: 80;
  stroke-dashoffset: 80;
  animation: dash 1s ease-in-out forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

#spinner .delay-1{
  animation-delay: 1s;
}

#spinner .delay-2{
  animation-delay: 2s;
}


#spinner .delay-3{
  animation-delay: 3s;
}

#spinner .delay-4{
  animation-delay: 4s;
}

#spinner .delay-5{
  animation-delay: 5s;
}

#spinner .delay-6{
  animation-delay: 6s;
}

#spinner .delay-7{
  animation-delay: 7s;
}

#spinner .delay-8{
  animation-delay: 8s;
}

#spinner .delay-9{
  animation-delay: 9s;
}

</style>
